import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './sensor-data-daily.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const SensorDataDailyDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const sensorDataDailyEntity = useAppSelector(state => state.sensorDataDaily.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sensorDataDailyDetailsHeading">
          <Translate contentKey="fleetSenseApp.sensorDataDaily.detail.title">SensorDataDaily</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{sensorDataDailyEntity.id}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="fleetSenseApp.sensorDataDaily.value">Value</Translate>
            </span>
          </dt>
          <dd>{sensorDataDailyEntity.value}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.sensorDataDaily.created">Created</Translate>
            </span>
          </dt>
          <dd>
            {sensorDataDailyEntity.created ? (
              <TextFormat value={sensorDataDailyEntity.created} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="fleetSenseApp.sensorDataDaily.sensor">Sensor</Translate>
          </dt>
          <dd>{sensorDataDailyEntity.sensor ? sensorDataDailyEntity.sensor.description : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.sensorDataDaily.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{sensorDataDailyEntity.truckImplement ? sensorDataDailyEntity.truckImplement.licensePlate : ''}</dd>
          {/* <dt>
            <Translate contentKey="fleetSenseApp.sensorDataDaily.company">Company</Translate>
          </dt>
          <dd>{sensorDataDailyEntity.company ? sensorDataDailyEntity.company.name : ''}</dd> */}
        </dl>
        <Button tag={Link} to="/sensor-data-daily" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sensor-data-daily/${sensorDataDailyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SensorDataDailyDetail;
